/**
 * Resource danh mục đối tượng
 * Created by AI Assistant
 */
export default {
  Title: 'Đối tượng',
  ObjectCode: 'Mã đối tượng *',
  ObjectCodeTitle: 'Mã đối tượng',
  ObjectType: 'Loại đối tượng',
  ObjectTypeTitle: 'Loại đối tượng',
  ObjectName: 'Tên đối tượng *',
  ObjectNameTitle: 'Tên đối tượng',
  Address: 'Địa chỉ',
  AddressTitle: 'Địa chỉ',
  IdentityNo: 'Số CCCD',
  IdentityNoTitle: 'Số chứng minh nhân dân',
  IssueDate: 'Ngày cấp',
  IssueDateTitle: 'Ngày cấp',
  IssueBy: 'Nơi cấp',
  IssueByTitle: 'Nơi cấp',
  Fax: 'Fax',
  FaxTitle: 'Fax',
  Tel: 'Điện thoại',
  TelTitle: 'Điện thoại',
  Email: 'Email',
  EmailTitle: 'Email',
  BankAccount: 'TK ngân hàng',
  BankAccountTitle: 'Tài khoản ngân hàng',
  BankName: 'Tên ngân hàng',
  BankNameTitle: 'Tên ngân hàng',
  TaxCode: 'Mã số thuế',
  TaxCodeTitle: 'Mã số thuế',
  TaxCodeInvalid: 'Mã số thuế không đúng định dạng (từ 10 đến 13 chữ số)',
  Description: 'Ghi chú',
  DescriptionTitle: 'Ghi chú',
  Area: 'Khu vực',
  AreaTitle: 'Khu vực',
};
